export default "/images/vendor/flag-icon-css/flags/4x3/ac.svg?75ec39aa6b6ab11f84407351b524bcdd";